'use client';

import React from 'react';
import Bathroom, {BathroomProps} from 'components/commercetools-ui/organisms/product/product-list/bathroom';
import { TasticProps } from 'frontastic/tastics/types';

const IndependentLivingCategory  = ({ data }: TasticProps<BathroomProps>) => {
    return <Bathroom data={data?.data?.dataSource} />;
};

export default IndependentLivingCategory;